export const en = {
    'clicks-forecast': 'Estimated clicks',
    'cost-forecast': 'Estimated spending, {currency}',
    name: 'Ad platform'
};
